import { render, staticRenderFns } from "./disclaimers.vue?vue&type=template&id=3562c6d7&scoped=true"
import script from "./disclaimers.vue?vue&type=script&lang=js"
export * from "./disclaimers.vue?vue&type=script&lang=js"
import style0 from "./disclaimers.vue?vue&type=style&index=0&id=3562c6d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3562c6d7",
  null
  
)

export default component.exports